import Button from "../../../components/ui/Button";
import { useForm } from "react-hook-form";
import { Controller } from "react-hook-form";
import SelectRoles from "../../../components/ui/Selects/Roles";
import { useTranslation } from "react-i18next";

const SearchForm = ({ formData, setFormData }) => {
  const form = useForm();
  const { t } = useTranslation();

  return (
    <form
      onSubmit={form.handleSubmit((data) => setFormData(data))}
      className="grid grid-cols-12 flex items-baseline gap-3 mb-8 p-5 shadow xl:shadow-none xl:px-6 xl:py-4 bg-white xl:bg-gray-100 rounded-md"
    >
      <div className="col-span-12 xl:col-span-5">
        <label>{t("partner.raison_soc")}</label>
        <div>
          <input
            type="text"
            className="w-full"
            {...form.register("name")}
            name="name"
          />
        </div>
      </div>

      <div className="col-span-12 xl:col-span-5">
        <label>Rôle</label>
        <Controller
          control={form.control}
          name="role"
          render={({ field: { onChange, onBlur, value, name, ref } }) => (
            <SelectRoles
              onBlur={onBlur}
              onChange={onChange}
              checked={value}
              inputRef={ref}
              emptyOpt={true}
            />
          )}
        />
      </div>

      <div className="col-span-12 xl:col-span-2">
        <label className="hidden xl:block">&nbsp;</label>
        <Button
          className="btn btn-primary w-full"
          isloading={form.formState.isSubmitting}
        >
          {t("global.search")}
        </Button>
      </div>
    </form>
  );
};

export default SearchForm;
